import {  FaExclamationTriangle, FaClock, FaTags } from "react-icons/fa"; 
import PharmacyComponent from "./PharmacyComponent";
import { RiCapsuleFill } from "react-icons/ri";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Whisper, Tooltip } from "rsuite";
import { FiSearch, FiX } from "react-icons/fi";
import BillingViewFilters from "../../BillingFilterJSON";
import DefaultPatientFilters from "../ClinicComponent/Filters/DefaultPatientFilters";

const PharmacyMedicine = () => {
  const navigate =useNavigate();
  const pharmacystyles = `
  .pharmacy-container {
    margin: 0 auto;   
    padding: 10px;
    height: 100%;
  }

  h1 {
    margin-bottom: 4px;
    font-size: 1.3rem;
  }

  .subtitle {
    color: #666;
    font-size: 1rem;
  }

  .header-1 {
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom: 20px;
  }

  .gradient-button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  /* Stats Panel */
  .stats-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 18px;
    margin-bottom: 24px;
  }

  .stat-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 14px rgba(0,0,0,0.06);
    padding: 20px;
    transition: 0.3s;
    position: relative;
    overflow: hidden;
  }

  .stat-card::after {
    content: "";
    position: absolute;
    top: -40px;
    right: -40px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    opacity: 0.15;
  }

  .stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  }

  .stat-icon {
    font-size: 2.2rem;
    margin-bottom: 12px;
  }

  .stat-title {
    color: #555;
    font-size: 1rem;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .stat-value {
    font-size: 1.2rem;
    font-weight: 700;
    color: #111;
  }

  .stat-sub {
    color: #777;
    font-size: 0.95rem;
    margin-top: 6px;
  }

  @media (max-width: 600px) {
    .pharmacy-container {
      padding: 8px;
    }
    .stat-card {
      padding: 15px;
    }
    .stat-value {
      font-size: 1.8rem;
    }
  }
  `;
    const [activeView, setActiveView] = useState("list");
    const [patientDetail, setPatientDetail] = useState("");
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [hasData, setHasData] = useState(true);


  const handleClearSearch = () => {
  setPatientDetail("");
  setSelectedFilters((prev) => {
    const { fullName, patientIDUniqueID, ...rest } = prev;
    return rest;
  });
  setHasData(true);
};

  const getButtonClasses = (view) => {
    const isActive = activeView === view;
    return [
      "flex-1 flex items-center justify-center h-[36px] w-[50px] transition-all",
      isActive
        ? "bg-[#203342] text-white"
        : "bg-white text-[#203342] hover:bg-gray-100",
    ].join(" ");
  };

  return (
    <>
      <style>{pharmacystyles}</style>
      <div className="pharmacy-container">
        {/* Header */}
        <div className="col-12 d-flex justify-content-between align-items-center"
            style={{ borderBottom: "1px dashed gray", paddingBottom: "1rem" }}>
          <div>
            <h2 className="h3 fw-bold mb-0" style={{fontSize:'24px'}}>Medicine Management</h2>
          </div>
          <div className="d-flex align-items-center gap-3">
                        <label className="relative">
                          <input
                            type="text"
                            className="pr-20 pl-4 py-2 border border-[#7eb592] rounded-lg w-full text-sm   focus:outline-none ring-2 ring-[#7eb592]/20 focus:outline focus:border-[#7eb592] focus:ring-2 focus:ring-[#7eb592]/20"
                            placeholder="Enter patient name or ID"
                            value={patientDetail}
                          />
                          {patientDetail && (
                            <span
                              className="absolute right-12 top-9 transform -translate-y-1/2 p-2 rounded-md text-gray-500 hover:text-red-400 cursor-pointer"
                              onClick={handleClearSearch}
                            >
                              <FiX size={16} />
                            </span>
                          )}
                          <span
                            className="absolute right-[0.3rem] top-9 transform -translate-y-1/2 bg-[#7eb592] hover:bg-gray-200 p-2 rounded-md text-white cursor-pointer"
                          >
                            <FiSearch size={16} />
                          </span>
                        </label>
          
                        
          
                        <Whisper
                          placement="top"
                          trigger="hover"
                          speaker={<Tooltip>Filter Options</Tooltip>}
                        >
                          <DefaultPatientFilters
                            defaultFilters={BillingViewFilters.default}
                            additionalFilters={BillingViewFilters.additional}
                            selectedFilters={selectedFilters}
                            setSelectedFilters={setSelectedFilters}
                            setHasData={setHasData}
                          />
                        </Whisper>
                        <button onClick={()=>navigate("/AddPharmacyUser")} className="gradient-button">+ Add New Medicine</button>
                      </div>

        </div>

        <PharmacyComponent />
      </div>
    </>
  );
};

export default PharmacyMedicine;
